import { useState } from 'react';
import { MonthPicker } from '@/components/calendar/MonthPicker';
import { ByExamTable } from '@/components/summary/ByExamTable';
import { ByServiceBreakdown } from '@/components/summary/ByServiceBreakdown';
import { ExportButton } from '@/components/summary/ExportButton';
import { MonthlyChart } from '@/components/summary/MonthlyChart';
import { TotalCard } from '@/components/summary/TotalCard';
import { useActiveCnpjId } from '@/features/services/hooks';
import { useSummary } from '@/features/summary/hooks';

function currentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export default function SummaryPage() {
  const [month, setMonth] = useState<string>(currentMonth());
  const { cnpjId } = useActiveCnpjId();
  const query = useSummary(month, cnpjId);
  const data = query.data;

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-wrap items-center justify-between gap-3 print:hidden">
        <div>
          <h1 className="font-display text-2xl font-semibold">Resumo</h1>
          <p className="text-sm text-(--color-fg-muted)">
            Dashboard mensal consolidado.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <MonthPicker month={month} onChange={setMonth} />
          <ExportButton month={month} />
        </div>
      </header>

      {query.isError ? (
        <p
          role="alert"
          className="rounded-md border border-(--color-error) bg-(--color-surface) p-4 text-sm text-(--color-error)"
        >
          Não foi possível carregar o resumo do mês. Tente novamente.
        </p>
      ) : null}

      <TotalCard
        total={data?.total ?? 0}
        shiftsCount={data?.shiftsCount ?? 0}
        itemsCount={data?.itemsCount ?? 0}
        isLoading={query.isLoading}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <ByServiceBreakdown items={data?.byService ?? []} />
        <MonthlyChart points={data?.monthlySeries ?? []} />
      </div>

      <ByExamTable items={data?.byExam ?? []} />
    </div>
  );
}
